'use strict';

import AppDispatcher from '../AppDispatcher';
import ActionTypes from '../constants/ActionTypes';
import MessageStore from './MessageStore';
import { createIndexedListStore, createListActionHandler } from '../utils/PaginatedStoreUtils';

var DraftFeedbackStore = createIndexedListStore({
  getDraftFeedbacks(draftUuid) {
    return this.getIds(draftUuid).map(MessageStore.get);
  }
});

var handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_DRAFT_FEEDBACKS,
  error: ActionTypes.REQUEST_DRAFT_FEEDBACKS_ERROR,
  success: ActionTypes.REQUEST_DRAFT_FEEDBACKS_SUCCESS
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([MessageStore.dispatchToken]);

  var action = payload.action,
      draftUuid = action.draftUuid;

  if (draftUuid) {
    handleListAction(action, DraftFeedbackStore.getList(draftUuid), DraftFeedbackStore.emitChange);
  }

  switch (action.type) {
  case ActionTypes.INVALIDATE_DRAFT_FEEDBACKS:
    DraftFeedbackStore.invalidate(draftUuid);
    break;
  }
});

module.exports = DraftFeedbackStore;


/** WEBPACK FOOTER **
 ** ./stores/DraftFeedbackStore.js
 **/